/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { PermanentServiceDiscountsRequest } from '../model';
// @ts-ignore
import { PermanentServiceDiscountsResponse } from '../model';
/**
 * ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGet - axios parameter creator
 * 
 * @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
 * @param {number} userId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetAxiosParamCreator (userId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiAdminUsersUserIdServiceDiscountsGet', 'userId', userId)
    const localVarPath = `/api/admin/users/{userId}/service-discounts`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPut - axios parameter creator
 * 
 * @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
 * @param {number} userId 
 * @param {PermanentServiceDiscountsRequest} [permanentServiceDiscountsRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutAxiosParamCreator (userId: number, permanentServiceDiscountsRequest?: PermanentServiceDiscountsRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiAdminUsersUserIdServiceDiscountsPut', 'userId', userId)
    const localVarPath = `/api/admin/users/{userId}/service-discounts`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(permanentServiceDiscountsRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ServiceDiscountApiApiServiceDiscountGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiServiceDiscountGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/ServiceDiscount`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ServiceDiscountApiApiServiceDiscountUserIdGet - axios parameter creator
 * 
 * @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
 * @param {number} userId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiServiceDiscountUserIdGetAxiosParamCreator (userId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiServiceDiscountUserIdGet', 'userId', userId)
    const localVarPath = `/api/ServiceDiscount/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ServiceDiscountApiApiServiceDiscountUserIdPut - axios parameter creator
 * 
 * @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
 * @param {number} userId 
 * @param {PermanentServiceDiscountsRequest} [permanentServiceDiscountsRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiServiceDiscountUserIdPutAxiosParamCreator (userId: number, permanentServiceDiscountsRequest?: PermanentServiceDiscountsRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiServiceDiscountUserIdPut', 'userId', userId)
    const localVarPath = `/api/ServiceDiscount/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(permanentServiceDiscountsRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ServiceDiscountApiApiServiceDiscountsGet - axios parameter creator
 * 
 * @summary  (Auth)
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ServiceDiscountApiApiServiceDiscountsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/service-discounts`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminUsersUserIdServiceDiscountsGet operation in ServiceDiscountApi.
 * @export
 * @interface ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetRequest
 */
export interface ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGet
     */
    readonly userId: number
}

/**
 * Request parameters for apiAdminUsersUserIdServiceDiscountsPut operation in ServiceDiscountApi.
 * @export
 * @interface ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutRequest
 */
export interface ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPut
     */
    readonly userId: number

    /**
     * 
     * @type {PermanentServiceDiscountsRequest}
     * @memberof ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPut
     */
    readonly permanentServiceDiscountsRequest?: PermanentServiceDiscountsRequest
}

/**
 * Request parameters for apiServiceDiscountUserIdGet operation in ServiceDiscountApi.
 * @export
 * @interface ServiceDiscountApiApiServiceDiscountUserIdGetRequest
 */
export interface ServiceDiscountApiApiServiceDiscountUserIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ServiceDiscountApiApiServiceDiscountUserIdGet
     */
    readonly userId: number
}

/**
 * Request parameters for apiServiceDiscountUserIdPut operation in ServiceDiscountApi.
 * @export
 * @interface ServiceDiscountApiApiServiceDiscountUserIdPutRequest
 */
export interface ServiceDiscountApiApiServiceDiscountUserIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ServiceDiscountApiApiServiceDiscountUserIdPut
     */
    readonly userId: number

    /**
     * 
     * @type {PermanentServiceDiscountsRequest}
     * @memberof ServiceDiscountApiApiServiceDiscountUserIdPut
     */
    readonly permanentServiceDiscountsRequest?: PermanentServiceDiscountsRequest
}

/**
* 
* @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
* @param {ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGet(requestParameters: ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<PermanentServiceDiscountsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
* @param {ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPut(requestParameters: ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiAdminUsersUserIdServiceDiscountsPutAxiosParamCreator(requestParameters.userId, requestParameters.permanentServiceDiscountsRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiServiceDiscountGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiServiceDiscountGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<PermanentServiceDiscountsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
* @param {ServiceDiscountApiApiServiceDiscountUserIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiServiceDiscountUserIdGet(requestParameters: ServiceDiscountApiApiServiceDiscountUserIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiServiceDiscountUserIdGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<PermanentServiceDiscountsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth policies: Auth:ManageUserServiceDiscounts)
* @param {ServiceDiscountApiApiServiceDiscountUserIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiServiceDiscountUserIdPut(requestParameters: ServiceDiscountApiApiServiceDiscountUserIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiServiceDiscountUserIdPutAxiosParamCreator(requestParameters.userId, requestParameters.permanentServiceDiscountsRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary  (Auth)
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ServiceDiscountApiApiServiceDiscountsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ServiceDiscountApiApiServiceDiscountsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<PermanentServiceDiscountsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
